var e=function(e){return"function"==typeof e&&Object.keys(e).length>0&&Object.values(e).every((function(e){return"function"==typeof e}))};export{e as isCompoundComponent};
